export default "__VITE_ASSET__DxxJTlRH__"